import { useState, useEffect } from "react";
import "./Dashboard.css";
import "./PaymentUsers.css";
import Sidebar from "../components/Layout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { fetchUser } from "../redux/authSlice";
import { updateProfile,uploadUserProfileImage  } from "../redux/profileFilterSlice";
import { saveSuccessStory, updateSuccessStorySlice, fetchAllSuccessStories } from "../redux/successStorySlice";
import userAvatar from "../img/user-avatar.png";
import { createPaymentUserAsync, deletePaymentUserAsync, fetchPaymentUsersAsync, updatePaymentUserAsync } from "../redux/paymentUsersSlice";
import Loader from "./Loader";

// const API = "http://localhost:5000/api/user";
const plans = {
  basic: 500,
  premium: 1000,
  vip: 2999,
};

const defaultPaymentForm = {
    userId:'',
  username: "",
  plan: "",
  amount: "",
  paymentStatus: "",
};



const defaultForm = {
  name: "",
  age: "",
  religion: "",
  caste: "",
  location: {
    country: "",
    state: "",
    city: ""
  },
  profession: "",
  salary: "",
  image: "",
  education: "",
  height: "",
  motherTongue: "",
  maritalStatus: "",
  gender: "",
  diet: "",
  smoking: "",
  drinking: "",
  about: "",
  prefAgeMin: "",
  prefAgeMax: "",
  prefHeight:"",
  prefReligion: "",
  prefCaste: "",
  prefLocation: "",
  prefEducation: "",
  prefProfession: "",
  prefSalaryMin: "",
};

const heights = [
  "4'10\"","5'0\"","5'2\"","5'4\"","5'6\"","5'8\"","5'10\"","6'0\"","6'2\"","6'4\"","6'6\"","6'8\"","6'10\"","7'0\""
];

const incomeRanges = ["3-6L", "6–12L", "12–25L", "25L+"];

const TABS = ["Overview", "Personal", "Professional", "Lifestyle", "Preferences", "Gallery"];

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

const initials = (name) =>
  name ? name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2) : "?";

export default function PaymentUsers({ user, onLogout }) {
  const dispatch = useDispatch();

  // ── Redux state ──────────────────────────────────────────────────────────────
  // fetchUser should resolve to { user, profile } or similar shape.
  // Adjust the selector path to match your actual authSlice state shape.
  const userFromStore = useSelector((state) => state.auth.user);
  console.log('userFromStore:',userFromStore);
  
  const profileFromStore = useSelector((state) => state.auth.profile); // add this to your slice if needed
console.log('profileFromStore:',profileFromStore);

  // ── Local state ──────────────────────────────────────────────────────────────
  const [profile, setProfile] = useState(null);   
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(defaultForm);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [shortlisted, setShortlisted] = useState([]);
  const [profileImage, setProfileImage] = useState(null);
  const [paymentForm, setPaymentForm] = useState(defaultPaymentForm);
const [editId, setEditId] = useState(null);
    const [search, setSearch] = useState("");
//   const  users  = useSelector((state) => state.paymentUsers);
  const paymentUsersState = useSelector((state) => state.paymentUsers);

const users = Array.isArray(paymentUsersState?.users)
  ? paymentUsersState.users
  : paymentUsersState?.users?.data || [];
  const userFromLoginResponse = useSelector((state) => state.auth.loginResponse);
  const allSuccessStories = useSelector((state) => state.successStories.stories);

  // Fetch stories (replace with API)
  useEffect(() => {
    setLoading(true);
    dispatch(fetchPaymentUsersAsync()).finally(() => setLoading(false));
  }, []);
   
  const [currentPage, setCurrentPage] = useState(1);

const goToPage = (page) => {
  if (page < 1 || page > totalPages) return;
  setCurrentPage(page);
};

const getPageNumbers = () => {
  const pages = [];
  const maxVisiblePages = 5;

  let startPage = Math.max(currentPage - 2, 1);
  let endPage = startPage + maxVisiblePages - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(endPage - maxVisiblePages + 1, 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return pages;
};

  // ── Derived display values ───────────────────────────────────────────────────
  const displayName =
    user?.username || user?.name ||
    userFromStore?.username || userFromStore?.name || "User";

  const displayEmail = user?.email || userFromStore?.email || "";

  const memberSince = (user?.createdAt || userFromStore?.createdAt)
    ? new Date(user?.createdAt || userFromStore?.createdAt).toLocaleDateString("en-IN", {
        month: "short",
        year: "numeric",
      })
    : "Member";

    // useEffect(() => {
    //   dispatch(fetchMatches());
    // }, [dispatch]);



  useEffect(() => {
  if (userFromStore?.profile) {
    setProfile(userFromStore.profile);
    console.log("profile:", userFromStore.profile);
  }
}, [userFromStore]);

useEffect(() => {
  if (profile?.photos?.length) {
    const primary = profile.photos.find((p) => p.isPrimary);
    setProfileImage(primary?.url || profile.photos[0]?.url);
  }
}, [profile]);

  // Pre-fill form name from logged-in user when opening "add" mode
  useEffect(() => {
    if (!editId) {
      setForm((prev) => ({ ...prev, name: displayName }));
    }
  }, [displayName, editId]);
  

  // ── Toast helper ─────────────────────────────────────────────────────────────
  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  // ── Form handlers ────────────────────────────────────────────────────────────
  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async () => {
    if (!form.fullName || !form.age) return showToast("Name & Age are required", "error");
    setLoading(true);
    try {
      if (editId) {
        // Update existing profile
        // await axios.post(`${API}/`, form, authHeaders());
        await dispatch(updateProfile({ ...form, id: editId })).unwrap();
        await dispatch(fetchUser()).unwrap(); // refresh user/profile in Redux
        showToast("Profile updated!");
      } else {
        // Create new profile
        // await axios.post(API, form, authHeaders());
        await dispatch(updateProfile({ ...form })).unwrap();
        await dispatch(fetchUser()).unwrap(); // refresh user/profile in Redux

        showToast("Profile saved!");
      }
      setEditId(null);
      setShowForm(false);
      // await fetchProfile(); // refresh the displayed profile

    } catch (err) {
      showToast(err?.response?.data?.message || "Error saving profile", "error");
    }
    setLoading(false);
  };



  const handleImageUpload = async (e, userId) => {
  const file = e.target.files[0];
  if (!file) return;
  const allowedTypes = ["image/jpeg", "image/png", "image/webp", "image/gif"];
  if (!allowedTypes.includes(file.type)) {
    showToast("Only JPG, PNG, WEBP, or GIF images are allowed", "error");
    e.target.value = "";
    return;
  }
  // Size validation (2MB)
  if (file.size > 2 * 1024 * 1024) {
  const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
  showToast(`Image too large (${fileSizeMB} MB). Maximum allowed size is 2MB`, "error");
  e.target.value = "";
  return;
}
  const formData = new FormData();
  formData.append("image", file);
  try {
    //  In handleImageUpload in Dashboard.jsx
const res = await dispatch(uploadUserProfileImage({ profileId: userId, formData })).unwrap();
if (res.profile) {
  setProfile(res.profile);
  showToast("Photo uploaded successfully!");
}
    
  } catch (err) {
    showToast("Image upload failed", "error");
    console.error(err);
  }
};

  // const toggleShortlist = (id) =>
  //   setShortlisted((prev) =>
  //     prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
  //   );

  // A stable random score per profile load
  const [compatibilityScore] = useState(() => Math.floor(60 + Math.random() * 35));

  // ── Stats derived from profile existence ─────────────────────────────────────
  const stats = {
    total: profile ? 1 : 0,
    matched: profile ? Math.floor(Math.random() * 40 + 10) : 0,
    shortlisted: shortlisted.length,
    viewed: profile ? Math.floor(Math.random() * 20 + 5) : 0,
  };



  // Add / Update Story
  const handleSave = async (data) => {
    console.log('Saving story:', data);
    
    if (data._id) {
      // update
      // setStories((prev) =>
      //   prev.map((s) => (s._id === data._id ? data : s))
      // );
      console.log('Updated_story_data:', data);
      
      await dispatch(updateSuccessStorySlice(data)); // dispatch to Redux (and API) as well
    } else {
      
      // create
      // const newStory = { ...data, _id: Date.now() };
      // setStories((prev) => [...prev, newStory]);
      await dispatch(saveSuccessStory(data)); // dispatch to Redux (and API) as well
    }

    await dispatch(fetchAllSuccessStories());

    setShowForm(false);
  };

  const handlePaymentChange = (e) => {
  const { name, value } = e.target;

  if (name === "plan") {
    setPaymentForm((prev) => ({
      ...prev,
      plan: value,
      amount: plans[value],
    }));
  } else {
    setPaymentForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};

const handlePaymentSubmit = async (e) => {
  e.preventDefault();

  try {
    if (editId) {
      await dispatch(
        updatePaymentUserAsync({
          id: editId,
          paymentUserData: paymentForm,
        })
      ).unwrap().then((res) => {
        console.log('Update Payment Response:', res);
        
showToast("Payment updated successfully");
        dispatch(fetchPaymentUsersAsync());
      });

      
    } else {
      await dispatch(
        createPaymentUserAsync(paymentForm)
      ).unwrap().then((res) => {
        console.log('Create Payment Response:', res);

      showToast("Payment added successfully");
    });

      dispatch(fetchPaymentUsersAsync());
    }


    setPaymentForm(defaultPaymentForm);
    setEditId(null);
    setShowForm(false);
  } catch (err) {
    showToast("Something went wrong", "error");
  }
};

const handleEdit = (item) => {
  setPaymentForm({
    userId: item._id,
    username: item.userName,
    plan: item.plan,
    amount: item.amount,
    paymentStatus: item.paymentStatus,
    paymentId: item.paymentId,
  });

  setEditId(item.paymentId);
  setShowForm(true);
};

const handleDelete = async (id) => {
    console.log('Deleting payment with ID:', id);
    
    //check id is null or undefined
  if (!id) return showToast("Invalid payment ID", "error");
  if (!window.confirm("Delete payment?")) return;

  try {
    await dispatch(deletePaymentUserAsync(id)).unwrap();

    showToast("Deleted successfully");

    dispatch(fetchPaymentUsersAsync());
  } catch (err) {
    showToast("Delete failed", "error");
  }
};

const filteredUsers = search
  ? users.filter((item) =>
      item.userName
        ?.toLowerCase()
        .includes(search.toLowerCase())
    )
  : users;
console.log('filteredUsers:', filteredUsers);

const itemsPerPage = 6;
const totalPages = Math.max(1, Math.ceil(filteredUsers.length / itemsPerPage));
const currentPaymentUsersPage = Math.min(currentPage, totalPages);
const startIndex = (currentPaymentUsersPage - 1) * itemsPerPage;
const paginatedUsers = filteredUsers.slice(startIndex, startIndex + itemsPerPage);



  // ── Render ───────────────────────────────────────────────────────────────────
  return (
    <>
      <div className="app">
        {loading && <Loader />}
        <Sidebar profileImage={profileImage} profileDetails={profile} />

        <main className="main">
          {/* Header */}
          <div className="main-header">
            <div className="main-header-left">
              <h1 className="page-title">
                Matrimony <span>Payment Users</span>
              </h1>
              <p className="page-sub">
                Welcome back, <strong>{displayName}</strong>
              </p>
            </div>
            <div className="main-header-right">
              
            </div>
          </div>

          {/* Profile detail or empty state */}
          <div className="tab-content">
            <div className="profile-detail">
              {/* Top Bar */}
              {!showForm && (
                <div className="story-header">
                  <h3>Payment Users</h3>
                   <div className="header-actions">
    <input
      type="text"
      placeholder="Search by user name"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="search-input"
    />

    {/* <button
      className="add-btn"
      onClick={() => setShowForm(true)}
    >
      + Add Payment
    </button> */}
  </div>
                </div>
              )}

              {/* Table */}
                          {!showForm && (
                              <div className="table-wrapper">
                                  <table className="story-table">
                                      <thead>
                                          <tr>
                                              {/* <th>Image</th> */}
                                              {/* //add serial number column */}
                                              <th>#</th>
                                              <th>User Name</th>
                                              <th>Contact</th>
                                              <th>Plan</th>
                                              <th>Amount</th>
                                              <th>Payment Status</th>
                                              <th>Actions</th>
                                          </tr>
                                      </thead>

                                      <tbody>
                                        {/* //no data found state */}
                                          {paginatedUsers?.length === 0 && (
                                              <tr>
                                                  <td colSpan="7" className="text-center">
                                                      No payment users found.
                                                  </td>
                                              </tr>
                                          )}
                                          {paginatedUsers?.map((item, index) => (
                                              <tr key={item._id}>
                                                  <td>{index + 1}</td>
                                                  <td>{item.userName}</td>
                                                  <td>{item.phone}</td>
                                                  <td>{item.plan}</td>
                                                  <td>₹{item.amount}</td>
                                                  <td>{item.paymentStatus}</td>

                                                  <td>
                                                  <button
                                                    className="edit-btn"
                                                    onClick={() => handleEdit(item)}
                                                    title="Edit"
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="15"
                                                      height="15"
                                                      viewBox="0 0 24 24"
                                                      fill="none"
                                                      stroke="currentColor"
                                                      strokeWidth="2"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    >
                                                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                                    </svg>
                                                  </button>

                                                  <button
                                                    className="delete-btn"
                                                    onClick={() => handleDelete(item.paymentId)}
                                                    title="Delete"
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="15"
                                                      height="15"
                                                      viewBox="0 0 24 24"
                                                      fill="none"
                                                      stroke="currentColor"
                                                      strokeWidth="2"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    >
                                                      <polyline points="3 6 5 6 21 6" />
                                                      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                                      <path d="M10 11v6" />
                                                      <path d="M14 11v6" />
                                                      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                                                    </svg>
                                                  </button>
                                                </td>
                                              </tr>
                                          ))}
                                      </tbody>
                                  </table>
                              </div>
                          )}

              {/* Form */}
                          {showForm && (
                              <div className="form-card">
                                  <form onSubmit={handlePaymentSubmit} className="payment-form">

                                      <div className="form-group">
                                          <label>User Name</label>

                                          <input
                                              type="text"
                                              name="username"
                                              value={paymentForm.username}
                                              onChange={handlePaymentChange}
                                              required
                                          />
                                      </div>

                                      <div className="form-group">
                                          <label>Plan</label>

                                          <select
                                              name="plan"
                                              value={paymentForm.plan}
                                              onChange={handlePaymentChange}
                                              required
                                          >
                                              <option value="">Select Plan</option>
                                              <option value="basic">Basic</option>
                                              <option value="premium">Premium</option>
                                              <option value="vip">VIP</option>
                                          </select>
                                      </div>

                                      <div className="form-group">
                                          <label>Amount</label>

                                          <input
                                              type="text"
                                              name="amount"
                                              value={paymentForm.amount}
                                              readOnly
                                          />
                                      </div>

                                      <div className="form-group">
                                          <label>Payment Status</label>

                                          <select
                                              name="paymentStatus"
                                              value={paymentForm.paymentStatus}
                                              onChange={handlePaymentChange}
                                              required
                                          >
                                              <option value="">Select Status</option>
                                              <option value="PENDING">Pending</option>
                                              <option value="SUCCESS">Success</option>
                                              <option value="FAILED">Failed</option>
                                          </select>
                                      </div>

                                      <div className="form-actions">
                                          <button type="submit" className="save-btn">
                                              {editId ? "Update" : "Update"}
                                          </button>

                                          <button
                                              type="button"
                                              className="cancel-btn"
                                              onClick={() => {
                                                  setShowForm(false);
                                                  setEditId(null);
                                                  setPaymentForm(defaultPaymentForm);
                                              }}
                                          >
                                              Cancel
                                          </button>
                                      </div>

                                  </form>
                              </div>
                          )}
            </div>
            
          </div>
            
           {filteredUsers.length > 0 && (
  <div className="pagination">
    <button
      onClick={() => goToPage(currentPage - 1)}
      disabled={currentPage === 1}
    >
      Prev
    </button>

    {getPageNumbers().map((page) => (
      <button
        key={page}
        className={currentPage === page ? "active" : ""}
        onClick={() => goToPage(page)}
      >
        {page}
      </button>
    ))}

    <button
      onClick={() => goToPage(currentPage + 1)}
      disabled={currentPage === totalPages}
    >
      Next
    </button>
  </div>
)}
        </main>
        {toast && <div className={`toast ${toast.type}`}>{toast.msg}</div>}
      </div>
     
    </>
  );
}